import type { CutStyle } from "../domain/types";

export const applyDashStyle = (
  ctx: CanvasRenderingContext2D,
  style: CutStyle,
  thicknessPx: number,
): void => {
  if (style === "dashed") {
    const d = Math.max(thicknessPx * 6, 4);
    ctx.setLineDash([d, d * 0.6]);
    ctx.lineCap = "butt";
  } else if (style === "dotted") {
    ctx.setLineDash([0, Math.max(thicknessPx * 2.2, 3)]);
    ctx.lineCap = "round";
  } else {
    ctx.setLineDash([]);
    ctx.lineCap = "butt";
  }
};
